export const replyTableConfig = {
  propList: [
    {prop: 'empName', label: '业务员', minWidth: '60', slotName: 'consumer'},
    {prop: 'statisticsCount', label: '回复客户数', minWidth: '60', sortable: true}
  ]
}
